import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const deliveryTypeApi = createApi({
  reducerPath: 'deliveryTypeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['deliveryType'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getDeliveryTypeList: builder.query({
      query: () => ({
        method: 'GET',
        path: `DeliveryTypes`,
      }),
      providesTags: ['deliveryType'],
    }),
    createNewDeliveryType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'DeliveryTypes',
      }),
      invalidatesTags: ['deliveryType'],
    }),
    updateDeliveryType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: `DeliveryTypes`,
      }),
      invalidatesTags: ['deliveryType'],
    }),
    deleteDeliveryType: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `DeliveryTypes/${id}`,
      }),
      invalidatesTags: ['deliveryType'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const deliveryTypeApiReducerName = deliveryTypeApi.reducerPath;
export const deliveryTypeApiReducer = deliveryTypeApi.reducer;
export const deliveryTypeApiMiddleware = deliveryTypeApi.middleware;

export const {
  useGetDeliveryTypeListQuery,
  useCreateNewDeliveryTypeMutation,
  useUpdateDeliveryTypeMutation,
  useDeleteDeliveryTypeMutation,
} = deliveryTypeApi;
